<template>
    <VModalWrapper :title="title" v-on="listeners" v-bind="attributes">
        <p class="modal_accept__message">{{ text }}</p>

        <div class="modal_accept__actions">
            <VButton type="button" class="active-form__action button_green-light" @click="cancel">
                {{ cancelTitle }}
            </VButton>

            <VButton type="submit" class="active-form__action button_green" @click="confirm">
                {{ confirmTitle }}
            </VButton>
        </div>
    </VModalWrapper>
</template>
<script>
// Components
import VButton from '../components/VButton/VButton.vue';
import VModalWrapper from '../components/VModalWrapper/VModalWrapper.vue';

// Other
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ModalNames from '../../js/enums/ModalNames';
import ModalMixin from '../../js/vue/mixins/ModalMixin';

@Component({
    components: {
        VButton,
        VModalWrapper,
    },
})
class VConfirmModal extends ModalMixin {
    @Prop({ type: String, default: ModalNames.CONFIRM })
    name;
    @Prop({ type: String, default: 'Требуется действие пользователя' })
    defaultTitle;

    text = '';
    cancelTitle = '';
    confirmTitle = '';
    cancelAction = null;
    confirmAction = null;

    confirm() {
        this.confirmAction?.();
        this.resolve();
        this.hide();
    }

    cancel() {
        this.cancelAction?.();
        this.resolve();
        this.hide();
    }

    beforeOpen(event) {
        this.text = event.params.text;
        this.cancelTitle = event.params.cancelTitle;
        this.confirmTitle = event.params.confirmTitle;
        this.cancelAction = event.params.cancelAction;
        this.confirmAction = event.params.confirmAction;
    }

    beforeClose() {
        this.text = '';
        this.cancelTitle = '';
        this.confirmTitle = '';
        this.cancelAction = null;
        this.confirmAction = null;
    }
}

export default VConfirmModal;
</script>
<style lang="scss">
.modal_accept {
    &__message {
        margin: 0 0 40px 0;
        font-size: 1.2rem;
        text-align: center;
    }
    &__actions {
        display: flex;
    }
}
</style>
